import React, { useState } from 'react';
import ReactMarkDown from 'react-markdown';
import { FiMaximize2 } from 'react-icons/fi';
import { FiMinimize2 } from 'react-icons/fi';

function MarkDown() {
  const placeholder = `# Welcome to my React Markdown Previewer!

## This is a sub-heading...
### And here's some other cool stuff:

Heres some code, \`<div></div>\`, between 2 backticks.

\`\`\`
// this is multi-line code:

function anotherExample(firstLine, lastLine) {
  if (firstLine == '\`\`\`' && lastLine == '\`\`\`') {
    return multiLineCode;
  }
}
\`\`\`

You can also make text **bold**... whoa!
Or _italic_.
Or... wait for it... **_both!_**
And feel free to go crazy ~~crossing stuff out~~.

There's also [links](https://www.freecodecamp.com), and
> Block Quotes!

And if you want to get really crazy, even tables:

Wild Header | Crazy Header | Another Header?
------------ | ------------- | -------------
Your content can | be here, and it | can be here....
And here. | Okay. | I think we get it.

- And of course there are lists.
  - Some are bulleted.
     - With different indentation levels.
        - That look like this.


1. And there are numbererd lists too.
1. Use just 1s if you want!
1. And last but not least, let's not forget embedded images:

![React Logo w/ Text](https://goo.gl/Umyytc)
`;
  const [markDown, setMarkDown] = useState(placeholder);

  const [previewExpand, setPreviewExpand] = useState(false);
  const [editorExpand, setEditorExpand] = useState(false);

  const handleChange = (e) => {
    setMarkDown(e.target.value);
  };

  const previewClickHandler = (e) => {
    e.preventDefault();
    setPreviewExpand(!previewExpand);
  };

  const editorClickHandler = (e) => {
    e.preventDefault();
    setEditorExpand(!editorExpand);
  };

  return (
    <div className='container'>
      <div className={editorExpand ? 'view active' : 'view'}>
        <div className='header'>
          <p>{`<Editor/>`}</p>
          <button onClick={editorClickHandler} className='btn'>
            {editorExpand ? <FiMinimize2 /> : <FiMaximize2 />}
          </button>
        </div>
        <textarea
          id='editor'
          value={markDown}
          onChange={handleChange}
        ></textarea>
      </div>

      <div className={previewExpand ? 'view active' : 'view'}>
        <div className='header' id='view-header'>
          <p>Preview</p>
          <button onClick={previewClickHandler} className='btn'>
            {previewExpand ? <FiMinimize2 /> : <FiMaximize2 />}
          </button>
        </div>
        <article id='preview'>
          <ReactMarkDown>{markDown}</ReactMarkDown>
        </article>
      </div>
    </div>
  );
}

export default MarkDown;
